export const MONTH_RANGE_PATTERN = /^(\d{4})-(0[1-9]|1[0-2])-01$/;
export const PAYROLL_KEY_SEPARATOR = ':';
export const DATE_PART_SEPARATOR = '-';
export const REPORT_SERVICE_EMPTY_VALUE = '';
export const YEAR_CAPTURE_INDEX = 1;
export const MONTH_CAPTURE_INDEX = 2;
export const LAST_DAY_OF_PREVIOUS_MONTH = 0;
export const MINIMUM_TASK_LINE_COUNT = 0;
export const FIRST_REPORT_INDEX = 0;
export const NUMBER_VALUE_TYPE = 'number';
export const DEAL_PAYROLL_SERVICE_REQUIRED =
  'DealPayrollService is required for deal payroll requests';
export const REPORT_DATE_PATTERN =
  /^Report from (\d{4}-\d{2}-\d{2}) to (\d{4}-\d{2}-\d{2})$/;
export const REPORT_FROM_CAPTURE_INDEX = 1;
export const REPORT_TO_CAPTURE_INDEX = 2;



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/report.service.constants.ts